// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PrimaryLayout_contentContainer__2bD4z"};